import React, { useState } from 'react';
import { MenuItemsLanguages } from './MenuItems';
import './Dropdown.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../i18n';

function DropdownLanguage() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu clicked' : 'dropdown-menu'}
      >
        {MenuItemsLanguages.map((item, index) => {
          const Flag = item.icon; // <-- important

          return (
            <li key={index}>
              <Link
                className={item.cName}
                onClick={() => changeLanguage(item.value)}
              >
                {/* FLAG ICON */}
                <Flag style={{ width: '22px', height: '16px', marginRight: '10px' }} />

                {/* TEXT */}
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownLanguage;
